/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { academyAction } from "@redux/modules";

import showMessage from "@components/ShowMessage";
import showErrMessage from "@components/ShowErrMessage";

import ReactPlayer from "react-player";

// Header - Footer
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";

// Styles
import "./styles.scss";

const AcademyDetail = () => {
  const { topicId } = useParams();
  const dispatch = useDispatch();
  const [filteredAcademy, setFilteredAcademy] = useState(null);

  const academyList = useSelector((store) => store.academy.academyList);
  const academyDetailList = useSelector(
    (store) => store.academy.academyDetailList
  );

  const [shownQuestions, setShownQuestions] = useState([]); // Gösterilen soruların ID'lerini takip eder
  const [currentTime, setCurrentTime] = useState(0); // Videonun mevcut zamanı
  const [videoStarted, setVideoStarted] = useState(false); // Video başladı mı?
  const [showQuestion, setShowQuestion] = useState(false); // Sorunun görünürlük durumu
  const [activeItem, setActiveItem] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(true); // Videonun oynama durumu
  const [currentQuestions, setCurrentQuestions] = useState([]); // Aktif videonun soruları
  const [currentQuestion, setCurrentQuestion] = useState(null); // Şu an gösterilen soru
  const [questionTimer, setQuestionTimer] = useState(0); // Soru için kalan süre
  const [questionTimerInterval, setQuestionTimerInterval] = useState(null); // Timer interval'i
  const playerRef = useRef(null); // ReactPlayer referansı
  const [validVideos, setValidVideos] = useState(new Set()); // Geçerli video ID'lerini tutar

  useEffect(() => {
    if (topicId) {
      // Get Academy Detail List
      dispatch(academyAction.getAcademyList());
      dispatch(academyAction.getAcademyDetailList(topicId));
    }

    return () => {};
  }, [dispatch, topicId]);

  useEffect(() => {
    if (academyList?.length > 0 && topicId) {
      const filteredData = academyList.filter(
        (item) => item.id === parseInt(topicId)
      );
      setFilteredAcademy(filteredData);
    }

    return () => {};
  }, [academyList, topicId]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (playerRef.current && isPlaying && videoStarted) {
        const time = playerRef.current.getCurrentTime();
        setCurrentTime(time);

        // Zaman kontrolü ve sorunun daha önce gösterilip gösterilmediğini kontrol et
        const questionToShow = currentQuestions.find(
          (q) =>
            Math.floor(q.appearTime) === Math.floor(time) &&
            !shownQuestions.includes(q.id) && // Daha önce gösterilmediyse
            q.answerExpiredTime > 0 // answerExpiredTime 0'dan büyükse
        );

        // answerExpiredTime 0 olan soruları da shownQuestions'a ekle (gösterilmesin)
        const expiredQuestions = currentQuestions.filter(
          (q) =>
            Math.floor(q.appearTime) === Math.floor(time) &&
            !shownQuestions.includes(q.id) &&
            q.answerExpiredTime === 0
        );

        if (expiredQuestions.length > 0) {
          setShownQuestions((prev) => [
            ...prev,
            ...expiredQuestions.map((q) => q.id),
          ]);
        }

        if (questionToShow) {
          setCurrentQuestion(questionToShow); // Şu anki soruyu ayarla
          setShowQuestion(true); // Soruyu göster
          setIsPlaying(false); // Videoyu durdur
          setShownQuestions((prev) => [...prev, questionToShow.id]); // Gösterilen soruları güncelle

          // Timer'ı başlat (answerExpiredTime 0'dan büyükse)
          const timerDuration =
            questionToShow.answerExpiredTime > 0
              ? questionToShow.answerExpiredTime
              : 30; // Varsayılan 30 saniye
          setQuestionTimer(timerDuration);

          const timerInterval = setInterval(() => {
            setQuestionTimer((prev) => {
              if (prev <= 1) {
                // Süre doldu, otomatik olarak soruyu kapat
                clearInterval(timerInterval);

                // Timeout mesajını göster
                showErrMessage("Üzgünüz. Belirlenen sürede cevap vermediniz.");

                setShowQuestion(false);
                setIsPlaying(true);
                setCurrentQuestion(null);
                setQuestionTimer(0);
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
          setQuestionTimerInterval(timerInterval);
        }
      }
    }, 500);

    return () => clearInterval(interval); // Temizlik işlemi
  }, [currentQuestions, shownQuestions, isPlaying, videoStarted]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.code === "MediaPlayPause" || // Play/Pause tuşu
        event.code === "MediaTrackNext" || // İleri tuşu
        event.code === "MediaTrackPrevious" // Geri tuşu
      ) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const handlePlayPauseToggle = (event) => {
      if (event.code === "MediaPlayPause") {
        setIsPlaying((prev) => !prev); // Oynatma/Duraklatma kontrolü
      }
    };

    window.addEventListener("keydown", handlePlayPauseToggle);

    return () => {
      window.removeEventListener("keydown", handlePlayPauseToggle);
    };
  }, []);

  useEffect(() => {
    const blurPlayer = () => {
      if (playerRef.current) {
        try {
          const internalPlayer = playerRef.current.getInternalPlayer();
          if (internalPlayer && typeof internalPlayer.blur === "function") {
            internalPlayer.blur();
          }
        } catch (error) {
          console.log("Player blur error:", error);
        }
      }
    };

    document.addEventListener("visibilitychange", blurPlayer);

    return () => {
      document.removeEventListener("visibilitychange", blurPlayer);
    };
  }, []);

  useEffect(() => {
    if (academyDetailList && academyDetailList.length > 0) {
      // Video URL'lerini kontrol et
      validateAllVideoUrls(academyDetailList);

      if (
        academyDetailList[0].videoDetailDTOList &&
        academyDetailList[0].videoDetailDTOList.length > 0
      ) {
        // İlk geçerli videoyu bul
        const firstValidVideo = academyDetailList[0].videoDetailDTOList.find(
          (video) => video.videoUrl || video.embeddedVideoUrl
        );

        if (firstValidVideo) {
          // Default activeItem
          setActiveItem(firstValidVideo);

          // İlk videonun sorularını ayarla (sadece video yüklendiğinde, modal açılmaz)
          if (
            firstValidVideo.questionDTOList &&
            firstValidVideo.questionDTOList.length > 0
          ) {
            setCurrentQuestions(firstValidVideo.questionDTOList);
          } else {
            setCurrentQuestions([]);
          }

          if (firstValidVideo.embeddedVideoUrl) {
            setVideoUrl(firstValidVideo.embeddedVideoUrl);
          } else if (firstValidVideo.videoUrl) {
            setVideoUrl(firstValidVideo.videoUrl);
          }
        }
      }
    }
  }, [academyDetailList]);

  // Video URL'lerini kontrol eden fonksiyon
  const checkVideoUrl = async (videoUrl) => {
    try {
      const response = await fetch(videoUrl, {
        method: "HEAD",
        mode: "no-cors", // CORS hatalarını önlemek için
      });
      return true; // no-cors modunda response.ok her zaman true olur
    } catch (error) {
      console.warn("Video URL geçersiz:", videoUrl, error);
      return false;
    }
  };

  // Tüm video URL'lerini kontrol eden fonksiyon
  const validateAllVideoUrls = async (academyDetailList) => {
    const validVideoIds = new Set();

    for (const item of academyDetailList) {
      if (item.videoDetailDTOList) {
        for (const video of item.videoDetailDTOList) {
          let isValid = false;

          // embeddedVideoUrl varsa (YouTube gibi) geçerli kabul et
          if (video.embeddedVideoUrl) {
            isValid = true;
          }
          // videoUrl varsa kontrol et
          else if (video.videoUrl) {
            isValid = await checkVideoUrl(video.videoUrl);
          }

          if (isValid) {
            validVideoIds.add(video.videoId);
          }
        }
      }
    }

    setValidVideos(validVideoIds);
  };

  // Component unmount olduğunda timer'ları temizle
  useEffect(() => {
    return () => {
      if (questionTimerInterval) {
        clearInterval(questionTimerInterval);
      }
    };
  }, [questionTimerInterval]);

  const handleAnswer = (choiceId) => {
    // Timer'ı durdur
    if (questionTimerInterval) {
      clearInterval(questionTimerInterval);
      setQuestionTimerInterval(null);
    }

    // API'ye cevabı kaydet
    const questionData = {
      answerTime: new Date().toISOString(), // OffsetDateTime formatında
      answerSecond: Math.floor(currentTime), // Videonun mevcut saniyesi
      questionId: currentQuestion.id, // Soru ID'si
      choiceId: choiceId, // Seçilen cevap ID'si
    };

    dispatch(academyAction.saveQuestionAnswer(questionData))
      .then(() => {
        // Başarı mesajını göster
        showMessage("Cevabınız kaydedildi. Teşekkür ederiz.");
      })
      .catch((error) => {
        // Hata mesajını göster
        showErrMessage("Cevabınız kaydedilirken bir hata oluştu.");
        console.error("Save question answer error:", error);
      });

    setShowQuestion(false); // Soruyu gizle
    setIsPlaying(true); // Videoyu oynat
    setCurrentQuestion(null); // Şu anki soruyu temizle
    setQuestionTimer(0); // Timer'ı sıfırla
  };

  const handleChangeVideo = (item) => {
    // Sadece geçerli videoları değiştir
    if (!validVideos.has(item.videoId)) {
      console.warn("Geçersiz video seçildi:", item.videoId);
      return;
    }

    setActiveItem(item);
    setIsPlaying(true);

    // Gösterilen soruların cache ini temizler
    setShownQuestions([]);

    // Aktif soru ve timer'ı temizle
    setCurrentQuestion(null);
    setQuestionTimer(0);
    setShowQuestion(false);
    setVideoStarted(false); // Video başlama durumunu sıfırla

    // Timer interval'ini temizle
    if (questionTimerInterval) {
      clearInterval(questionTimerInterval);
      setQuestionTimerInterval(null);
    }

    // Aktif videonun sorularını ayarla
    if (item.questionDTOList && item.questionDTOList.length > 0) {
      setCurrentQuestions(item.questionDTOList);
    } else {
      setCurrentQuestions([]);
    }

    if (item.embeddedVideoUrl) {
      setVideoUrl(item.embeddedVideoUrl);
    } else if (item.videoUrl) {
      setVideoUrl(item.videoUrl);
    }
  };

  return (
    <>
      <Header />

      <main>
        <section className="bg-blue pt-5 pb-5">
          <div className="container">
            <div
              className="d-lg-flex d-none text-white small mb-5 opacity-50"
              data-title-background
            >
              <NavLink to="/" className="text-white text-decoration-none me-3">
                Anasayfa
              </NavLink>
              <span className="me-3">»</span>
              <NavLink
                to="/academy"
                className="text-white text-decoration-none me-3"
              >
                Akademi
              </NavLink>
              <span className="me-3">»</span>
              {filteredAcademy?.length > 0 &&
                filteredAcademy[0]?.videoCategoryName && (
                  <span className="text-white text-decoration-none">
                    {filteredAcademy[0].videoCategoryName}
                  </span>
                )}
            </div>

            {filteredAcademy?.length > 0 ? (
              <div
                className="row justify-content-center mb-5"
                data-title-background
              >
                <div className="col-xl-12 col-lg-12 text-center">
                  {filteredAcademy[0]?.topicName && (
                    <h1 className="lh-base mb-4 text-white">
                      {filteredAcademy[0]?.topicName}
                    </h1>
                  )}

                  <div className="opacity-100 small text-white">
                    {filteredAcademy[0]?.description && (
                      <span className="text-white">
                        {filteredAcademy[0].description}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <p>Academy bulunamadı yada yükleniyor...</p>
            )}
          </div>
        </section>

        <section className="position-relative py-5">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-8">
                {videoUrl && (
                  <ReactPlayer
                    width={"100%"}
                    ref={playerRef}
                    url={videoUrl}
                    playing={isPlaying}
                    controls={false}
                    tabIndex={-1} // Global medya erişimini sınırlandırır
                    playIcon={true}
                    onPlay={() => setVideoStarted(true)}
                    onPause={() => setVideoStarted(false)}
                  />
                )}

                {showQuestion && currentQuestion && (
                  <div className="question-overlay academy-question-modal">
                    <div className="question-box">
                      <div className="question-timer">
                        <span>Kalan Süre: {questionTimer} saniye</span>
                      </div>
                      <h3>{currentQuestion.title}</h3>
                      <p className="question-description">
                        {currentQuestion.description}
                      </p>
                      <div className="options">
                        {currentQuestion.questionChoiceListDTO.map((option) => (
                          <button
                            key={option.id}
                            onClick={() => handleAnswer(option.id)}
                          >
                            {option.description}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-12 col-md-4">
                {academyDetailList &&
                  academyDetailList.map((item) => (
                    <ul
                      key={item.subTopicId}
                      className="academy-detail-topic-list"
                    >
                      <li>
                        {item.subTopicName && item.subTopicName}

                        <ul className="academy-detail-subtopic-list">
                          {item.videoDetailDTOList &&
                            item.videoDetailDTOList.length > 0 &&
                            item.videoDetailDTOList
                              .filter(
                                (it) =>
                                  // Sadece geçerli video URL'leri olan videoları göster
                                  (it.videoUrl || it.embeddedVideoUrl) &&
                                  validVideos.has(it.videoId)
                              )
                              .map((it) => (
                                <li key={it.videoId}>
                                  <button
                                    className={
                                      activeItem?.videoId === it?.videoId
                                        ? "active"
                                        : ""
                                    }
                                    onClick={() => handleChangeVideo(it)}
                                  >
                                    {it.title}
                                  </button>
                                </li>
                              ))}
                        </ul>
                      </li>
                    </ul>
                  ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default AcademyDetail;
